'use client';

import type { ReactNode } from 'react';
import { useMemo } from 'react';

import type { ProductPageContextProps } from './ProductPage.context';
import { ProductPageContext } from './ProductPage.context';

export default function ProductPageProvider({
    children,
    loopProductData,
    marketConfig,
    dictionary,
}: ProductPageContextProps & {
    children: ReactNode;
}) {
    const value = useMemo(() => {
        return {
            loopProductData,
            marketConfig,
            dictionary,
        };
    }, [loopProductData, marketConfig, dictionary]);

    return (
        <ProductPageContext.Provider value={value}>
            {children}
        </ProductPageContext.Provider>
    );
}
